import api from "@/api/apiBoard";
// import { getTimeZone, convertTimeZone, setTimeZone } from "@/utils/timezone";

export default {
  namespaced: true,
  state() {
    return {
      // FAQ
      clickFAQ: false,

      // 언어
      langSelect: localStorage.getItem("patchLang") || "default",

      // 언어 드롭박스 열기/닫기
      clickLang: false,

      // 브리핑
      loadBrief: false, // 브리핑 로딩 완료 여부 확인
      loadDetail: false, // ai 브리핑 상세 페이지 로딩 완료 여부 확인
      brief: [], // 브리핑 리스트
      aiBrief: [], //ai브리핑리스트
      aiBriefTitleList: [], //ai 브리핑 제목 리스트

      aiId: [],

      // Detail array
      briefDetail: [],
      noticeDetail: [],

      // 브리핑 currentTab
      currentTab: "am-brief",

      // 공지
      noticeList: [], // 공지 리스트

      timetype: "AM", //AM, PM
      limit: 20, //ai brief 보여줄 갯수
      language: "default",
    };
  },
  mutations: {
    //언어설정
    setLanguage(state, value) {
      state.language = value;
    },
    //AM/PM
    setTimetype(state, value) {
      state.timetype = value;
    },
    // FAQ
    changeFAQ(state, payload) {
      state.clickFAQ = payload.state;
    },
    // 선택된 언어로 변경
    changeLang(state, value) {
      if (value != undefined) {
        state.langSelect = value.language;
        localStorage.setItem("patchLang", value.language);
        localStorage.setItem("userLang", value.display);
      } else {
        state.langSelect = "default";
      }
    },
    //언어 드롭박스 열기/닫기
    langClick(state, payload) {
      state.clickLang = payload.state;
    },
    // 브리핑 로드 여부 확인 변경
    changeLoadBrief(state, payload) {
      state.loadBrief = payload.state;
    },
    // 브리핑 로드 여부 확인 변경
    changeLoadAi(state, payload) {
      state.loadDetail = payload.state;
    },
    // 브리핑 currentTab 변경
    changeTab(state, value) {
      state.currentTab = value;
    },
    // 브리핑 상세페이지 내용
    detailBrief(state, value) {
      state.briefDetail = value;
    },
    // 공지 상세페이지 내용
    detailNotice(state, value) {
      state.noticeDetail = value;
    },
    //display 변경
    changeDisplay(state, value) {
      if (value == "Language") state.langSelect = "default";
      else if (value == "한국어") state.langSelect = "kr";
      else if (value == "English") state.langSelect = "en";
      else if (value == "日本語") state.langSelect = "jp";
      else if (value == "中文") state.langSelect = "cn";
      else if (value == "Tiếng Việt") state.langSelect = "vn";
    },
  },
  actions: {
    // 브리핑
    // 언어선택시 오전브리핑 api 호출 / 데이터 변경
    async getAMBrief(context) {
      try {
        const result = await api.getAMBoard(context.state.langSelect);
        if (result.isSuccess) {
          let data = result.data;
          for (let i = 0; i < data.length; i++) {
            // 날짜 형태 변경
            let Date = data[i].writeDate.split("T");
            let [year, month, day] = Date[0].split("-");
            data[i].Date = `${year}.${month}.${day}`;

            // 시간 형태 변경
            let [time, min] = Date[1].split(":");
            data[i].Time = `${time}:${min}`;

            // content 분리
            let content = data[i].content;

            const imgSrc = /<img.*?src=['"](.*?)['"].*?>/g;
            const imgTag = content.match(imgSrc);

            const srcImg = [];
            const context = [];

            if (imgTag) {
              imgTag.forEach((match) => {
                // content text 분리
                let conText = content.split(match)[0]; // 이미지 태그 이전의 텍스트
                if (
                  conText.trim() !== "" &&
                  !conText.trim().match(/^<p>\s*<\/p>$/)
                ) {
                  // 빈 태그 체크
                  context.push(conText.trim());
                }

                // content img 분리
                const conImg = match.match(/src=['"](.*?)['"]/)[1];
                srcImg.push(conImg);

                // 이미지 태그 이후의 텍스트
                if (content.split(match)[1]) {
                  content = content.split(match)[1];
                }
              });

              // 이미지 태그 이후의 텍스트 추가
              if (
                content.trim() !== "" &&
                !content.trim().match(/^<p>\s*<\/p>$/)
              ) {
                // 빈 태그 체크
                context.push(content.trim());
              }

              data[i].context = context;
              data[i].srcImg = srcImg;
            } else {
              // 이미지 태그가 없는 경우 전체 내용을 텍스트로 처리
              if (
                content.trim() !== "" &&
                !content.trim().match(/^<p>\s*<\/p>$/)
              ) {
                // 빈 태그 체크
                data[i].context = [content.trim()];
              } else {
                data[i].context = [];
              }
              data[i].srcImg = [];
            }
            // span 태그 내 style 제거
            data[i].context.forEach((text, index) => {
              data[i].context[index] = text.replace(
                /<span[^>]*?style=['"](.*?)['"][^>]*?>(.*?)<\/span>/g,
                "<span>$2</span>"
              );
            });
          }
          // 날짜&시간 기준 정렬
          data.sort((a, b) => {
            if (a.Date !== b.Date) {
              return b.Date.localeCompare(a.Date);
            } else {
              return b.Time.localeCompare(a.Time);
            }
          });
          context.state.brief = data;
          context.state.loadBrief = true;
        }
      } catch (error) {
        // // console.log("getAMBrief", error);
        return;
      }
    },
    // 언어선택시 오후브리핑 api 호출 / 데이터 변경
    async getPMBrief(context) {
      try {
        const result = await api.getPMBoard(context.state.langSelect);
        if (result.isSuccess) {
          let data = result.data;          

          for (let i = 0; i < data.length; i++) {
            // 날짜 형태 변경
            let Date = data[i].writeDate.split("T");
            let [year, month, day] = Date[0].split("-");
            data[i].Date = `${year}.${month}.${day}`;

            // 시간 형태 변경
            let [time, min] = Date[1].split(":");
            data[i].Time = `${time}:${min}`;

            // content 분리
            let content = data[i].content;

            const imgSrc = /<img.*?src=['"](.*?)['"].*?>/g;
            const imgTag = content.match(imgSrc);

            const srcImg = [];
            const context = [];

            if (imgTag) {
              imgTag.forEach((match) => {
                // content text 분리
                let conText = content.split(match)[0]; // 이미지 태그 이전의 텍스트
                context.push(conText.trim());

                // content img 분리
                const conImg = match.match(/src=['"](.*?)['"]/)[1];
                srcImg.push(conImg);

                // 이미지 태그 이후의 텍스트
                if (content.split(match)[1]) {
                  content = content.split(match)[1];
                }
              });

              // 이미지 태그 이후의 텍스트 추가
              context.push(content.trim());

              data[i].context = context.filter((text) => text.trim() !== ""); // 빈 문자열 제거
              data[i].srcImg = srcImg;
            } else {
              // 이미지 태그가 없는 경우 전체 내용을 텍스트로 처리
              data[i].context = [content.trim()];
              data[i].srcImg = [];
            }
            // span 태그 내 style 제거
            data[i].context.forEach((text, index) => {
              data[i].context[index] = text.replace(
                /<span[^>]*?style=['"](.*?)['"][^>]*?>(.*?)<\/span>/g,
                "<span>$2</span>"
              );
            });
          }
          // 날짜&시간 기준 정렬
          data.sort((a, b) => {
            if (a.Date !== b.Date) {
              return b.Date.localeCompare(a.Date);
            } else {
              return b.Time.localeCompare(a.Time);
            }
          });

          context.state.brief = data;
          context.state.loadBrief = true;
        }
      } catch (error) {
        // // console.log("getPMBrief", error);
        return;
      }
    },
    async getPickBrief(context) {
      try {
        const result = await api.getPickBoard(context.state.langSelect);
        if (result.isSuccess) {
          let data = result.data;
          for (let i = 0; i < data.length; i++) {
            // 날짜 형태 변경
            let Date = data[i].writeDate.split("T");
            let [year, month, day] = Date[0].split("-");
            data[i].Date = `${year}.${month}.${day}`;

            // 시간 형태 변경
            let [time, min] = Date[1].split(":");
            data[i].Time = `${time}:${min}`;

            // content 분리
            let content = data[i].content;

            const imgSrc = /<img.*?src=['"](.*?)['"].*?>/g;
            const imgTag = content.match(imgSrc);

            const srcImg = [];
            const context = [];

            if (imgTag) {
              imgTag.forEach((match) => {
                // content text 분리
                let conText = content.split(match)[0]; // 이미지 태그 이전의 텍스트
                if (
                  conText.trim() !== "" &&
                  !conText.trim().match(/^<p>\s*<\/p>$/)
                ) {
                  // 빈 태그 체크
                  context.push(conText.trim());
                }

                // content img 분리
                const conImg = match.match(/src=['"](.*?)['"]/)[1];
                srcImg.push(conImg);

                // 이미지 태그 이후의 텍스트
                if (content.split(match)[1]) {
                  content = content.split(match)[1];
                }
              });

              // 이미지 태그 이후의 텍스트 추가
              if (
                content.trim() !== "" &&
                !content.trim().match(/^<p>\s*<\/p>$/)
              ) {
                // 빈 태그 체크
                context.push(content.trim());
              }

              data[i].context = context;
              data[i].srcImg = srcImg;
            } else {
              // 이미지 태그가 없는 경우 전체 내용을 텍스트로 처리
              if (
                content.trim() !== "" &&
                !content.trim().match(/^<p>\s*<\/p>$/)
              ) {
                // 빈 태그 체크
                data[i].context = [content.trim()];
              } else {
                data[i].context = [];
              }
              data[i].srcImg = [];
            }
            // span 태그 내 style 제거
            data[i].context.forEach((text, index) => {
              data[i].context[index] = text.replace(
                /<span[^>]*?style=['"](.*?)['"][^>]*?>(.*?)<\/span>/g,
                "<span>$2</span>"
              );
            });
          }
          // 날짜&시간 기준 정렬
          data.sort((a, b) => {
            if (a.Date !== b.Date) {
              return b.Date.localeCompare(a.Date);
            } else {
              return b.Time.localeCompare(a.Time);
            }
          });
          context.state.brief = data;
          context.state.loadBrief = true;
        }
      } catch (error) {
        // // console.log("getAMBrief", error);
        return;
      }
    },
    // 언어선택X 오전브리핑 api 호출 / 데이터 변경
    async getAMAll(context) {
      try {
        const result = await api.getAllAM();
        if (result.isSuccess) {
          let data = result.data;

          for (let i = 0; i < data.length; i++) {
            // 날짜 형태 변경
            let Date = data[i].writeDate.split("T");
            let [year, month, day] = Date[0].split("-");
            data[i].Date = `${year}.${month}.${day}`;

            // 시간 형태 변경
            let [time, min] = Date[1].split(":");
            data[i].Time = `${time}:${min}`;

            // content 분리
            let content = data[i].content;

            const imgSrc = /<img.*?src=['"](.*?)['"].*?>/g;
            const imgTag = content.match(imgSrc);

            const srcImg = [];
            const context = [];

            if (imgTag) {
              imgTag.forEach((match) => {
                // content text 분리
                let conText = content.split(match)[0]; // 이미지 태그 이전의 텍스트
                context.push(conText.trim());

                // content img 분리
                const conImg = match.match(/src=['"](.*?)['"]/)[1];
                srcImg.push(conImg);

                // 이미지 태그 이후의 텍스트
                if (content.split(match)[1]) {
                  content = content.split(match)[1];
                }
              });

              // 이미지 태그 이후의 텍스트 추가
              context.push(content.trim());

              data[i].context = context.filter((text) => text.trim() !== ""); // 빈 문자열 제거
              data[i].srcImg = srcImg;
            } else {
              // 이미지 태그가 없는 경우 전체 내용을 텍스트로 처리
              data[i].context = [content.trim()];
              data[i].srcImg = [];
            }
            // span 태그 내 style 제거
            data[i].context.forEach((text, index) => {
              data[i].context[index] = text.replace(
                /<span[^>]*?style=['"](.*?)['"][^>]*?>(.*?)<\/span>/g,
                "<span>$2</span>"
              );
            });
          }
          // 날짜&시간 기준 정렬
          data.sort((a, b) => {
            if (a.Date !== b.Date) {
              return b.Date.localeCompare(a.Date);
            } else {
              return b.Time.localeCompare(a.Time);
            }
          });

          context.state.brief = data;
          context.state.loadBrief = true;
        }
      } catch (error) {
        // // console.log("getAMAll", error);
        return;
      }
    },
    // 언어선택X 오후브리핑 api 호출 / 데이터 변경
    async getPMAll(context) {
      try {
        const result = await api.getAllPM();
        if (result.isSuccess) {
          let data = result.data;
          for (let i = 0; i < data.length; i++) {
            // 날짜 형태 변경
            let Date = data[i].writeDate.split("T");
            let [year, month, day] = Date[0].split("-");
            data[i].Date = `${year}.${month}.${day}`;

            // 시간 형태 변경
            let [time, min] = Date[1].split(":");
            data[i].Time = `${time}:${min}`;

            // content 분리
            let content = data[i].content;

            const imgSrc = /<img.*?src=['"](.*?)['"].*?>/g;
            const imgTag = content.match(imgSrc);

            const srcImg = [];
            const context = [];

            if (imgTag) {
              imgTag.forEach((match) => {
                // content text 분리
                let conText = content.split(match)[0]; // 이미지 태그 이전의 텍스트
                context.push(conText.trim());

                // content img 분리
                const conImg = match.match(/src=['"](.*?)['"]/)[1];
                srcImg.push(conImg);

                // 이미지 태그 이후의 텍스트
                if (content.split(match)[1]) {
                  content = content.split(match)[1];
                }
              });

              // 이미지 태그 이후의 텍스트 추가
              context.push(content.trim());

              data[i].context = context.filter((text) => text.trim() !== ""); // 빈 문자열 제거
              data[i].srcImg = srcImg;
            } else {
              // 이미지 태그가 없는 경우 전체 내용을 텍스트로 처리
              data[i].context = [content.trim()];
              data[i].srcImg = [];
            }
            // span 태그 내 style 제거
            data[i].context.forEach((text, index) => {
              data[i].context[index] = text.replace(
                /<span[^>]*?style=['"](.*?)['"][^>]*?>(.*?)<\/span>/g,
                "<span>$2</span>"
              );
            });
          }
          // 날짜&시간 기준 정렬
          data.sort((a, b) => {
            if (a.Date !== b.Date) {
              return b.Date.localeCompare(a.Date);
            } else {
              return b.Time.localeCompare(a.Time);
            }
          });

          context.state.brief = data;
          context.state.loadBrief = true;
        }
      } catch (error) {
        return;
      }
    },
    async getPickAll(context) {
      try {
        const result = await api.getAllPick();
        if (result.isSuccess) {
          let data = result.data;

          for (let i = 0; i < data.length; i++) {
            // 날짜 형태 변경
            let Date = data[i].writeDate.split("T");
            let [year, month, day] = Date[0].split("-");
            data[i].Date = `${year}.${month}.${day}`;

            // 시간 형태 변경
            let [time, min] = Date[1].split(":");
            data[i].Time = `${time}:${min}`;

            // content 분리
            let content = data[i].content;

            const imgSrc = /<img.*?src=['"](.*?)['"].*?>/g;
            const imgTag = content.match(imgSrc);

            const srcImg = [];
            const context = [];

            if (imgTag) {
              imgTag.forEach((match) => {
                // content text 분리
                let conText = content.split(match)[0]; // 이미지 태그 이전의 텍스트
                context.push(conText.trim());

                // content img 분리
                const conImg = match.match(/src=['"](.*?)['"]/)[1];
                srcImg.push(conImg);

                // 이미지 태그 이후의 텍스트
                if (content.split(match)[1]) {
                  content = content.split(match)[1];
                }
              });

              // 이미지 태그 이후의 텍스트 추가
              context.push(content.trim());

              data[i].context = context.filter((text) => text.trim() !== ""); // 빈 문자열 제거
              data[i].srcImg = srcImg;
            } else {
              // 이미지 태그가 없는 경우 전체 내용을 텍스트로 처리
              data[i].context = [content.trim()];
              data[i].srcImg = [];
            }
            // span 태그 내 style 제거
            data[i].context.forEach((text, index) => {
              data[i].context[index] = text.replace(
                /<span[^>]*?style=['"](.*?)['"][^>]*?>(.*?)<\/span>/g,
                "<span>$2</span>"
              );
            });
          }
          // 날짜&시간 기준 정렬
          data.sort((a, b) => {
            if (a.Date !== b.Date) {
              return b.Date.localeCompare(a.Date);
            } else {
              return b.Time.localeCompare(a.Time);
            }
          });

          context.state.brief = data;
          context.state.loadBrief = true;
        }
      } catch (error) {
        // // console.log("getAMAll", error);
        return;
      }
    },
    // 공지 언어선택시
    async getBoardNotice(context) {
      try {
        const result = await api.getNoticeBoard(context.state.langSelect);
        if (result.isSuccess) {
          let data = result.data;
          // if (context.state.langSelect == 'en') {
          //   data = [
          //     {
          //       content: "Test Content",
          //       language: "en",
          //       thumbnailUrl: "",
          //       title: "Test",
          //       writeDate: "2026-06-23T19:11:21"
          //     }
          //   ]
          // }
          for (let i = 0; i < data.length; i++) {
            // 날짜 형태 변경
            let Date = data[i].writeDate.split("T");
            let [year, month, day] = Date[0].split("-");
            data[i].Date = `${year}.${month}.${day}`;

            // 시간 형태 변경
            let [time, min] = Date[1].split(":");
            data[i].Time = `${time}:${min}`;

            // content img style 삭제
            let content = data[i].content;
            const imgSrc = /<img.*?src=['"](.*?)['"].*?>/g;
            let matches = content.match(imgSrc);

            if (matches) {
              matches.forEach((match) => {
                // 이미지 태그 내의 style 속성 찾기
                let styleMatch = match.match(/style=['"](.*?)['"]/);
                if (styleMatch) {
                  // style 속성 전체를 찾아서 공백으로 변경
                  let styleAttr = styleMatch[0];
                  content = content.replace(styleAttr, "");
                }
              });
              // 변경된 content를 data[i].newContent 에 저장
              data[i].newContent = content;
            }
          }
          // 날짜&시간 기준 정렬
          data.sort((a, b) => {
            if (a.Date !== b.Date) {
              return b.Date.localeCompare(a.Date);
            } else {
              return b.Time.localeCompare(a.Time);
            }
          });
          // console.log('data', data)
        
          context.state.noticeList = data;
        }
      } catch (error) {
        return;
      }
    },
    // 공지 언어선택X
    async getNoticeAll(context) {
      try {
        const result = await api.getAllNotice();
        if (result.isSuccess) {
          let data = result.data;
          // data = [
          //   {
          //     content: "\n    <div class=\"ai-news\">\n    <img src=\"https://gpt-premium-charts.s3.ap-northeast-2.amazonaws.com/charts/day-chart-03b70c56-501b-42dd-9a3f-903bd88ae0a7.png\" alt=\"\" class=\"ai-article-img\" />\n <p>Test</p>\n  </div>\n",
          //     language: "en",
          //     thumbnailUrl: 'https://brunch.co.kr/@wookgon/260',
          //     title: "Test",
          //     writeDate: "2026-07-08T19:11:21"
          //   },
          //   {
          //     content: "Test Content",
          //     language: "ko",
          //     thumbnailUrl: "",
          //     title: "Test11",
          //     writeDate: "2026-06-23T19:11:21"
          //   },
          //   {
          //     content: "Test Content",
          //     language: "vi",
          //     thumbnailUrl: "",
          //     title: "Test22",
          //     writeDate: "2026-06-23T19:11:21"
          //   }
          // ]
          for (let i = 0; i < data.length; i++) {
            // 날짜 형태 변경
            let Date = data[i].writeDate.split("T");
            let [year, month, day] = Date[0].split("-");
            data[i].Date = `${year}.${month}.${day}`;

            // 시간 형태 변경
            let time = Date[1].split(":")[0];
            let min = Date[1].split(":")[1];
            data[i].Time = `${time}:${min}`;

            // content img style 삭제
            let content = data[i].content;
            const imgSrc = /<img.*?src=['"](.*?)['"].*?>/g;
            let matches = content.match(imgSrc);

            if (matches) {
              matches.forEach((match) => {
                // 이미지 태그 내의 style 속성 찾기
                let styleMatch = match.match(/style=['"](.*?)['"]/);
                if (styleMatch) {
                  // style 속성 전체를 찾아서 공백으로 변경
                  let styleAttr = styleMatch[0];
                  content = content.replace(styleAttr, "");
                }
              });
              // 변경된 content를 data[i].newContent 에 저장
              // console.log(content)
              data[i].newContent = content;
            }
          }
          // 날짜&시간 기준 정렬
          data.sort((a, b) => {
            if (a.Date !== b.Date) {
              return b.Date.localeCompare(a.Date);
            } else {
              return b.Time.localeCompare(a.Time);
            }
          });
           
          context.state.noticeList = data;
        }
      } catch (error) {
        return;
      }
    },
    // AiBrief 상세 페이지 api 호출
    async getLangAiBrief(context, id) {
      let language = context.state.language;

      try {
        const result = await api.getAiBrief(id, language);
        let data = result.result;

        let date = data.date.split("T")[0].replaceAll("-", ".");
        let time = data.date.split("T")[1].substr(0, 5);

        data.Date = date;
        data.Time = time;

        const imgSrc = /<img.*?src=['"](.*?)['"].*?>/g;

        data.content = data.content.replace(imgSrc, (imgTag) => {
          let srcMatch = imgTag.match(/src=['"](.*?)['"]/);
          if (srcMatch && (srcMatch[1] === "None" || srcMatch[1] === "")) {
            return '<img src="" alt="" class="ai-article-img" />';
          }
          return imgTag;
        });

        context.state.aiBrief = data;
        context.state.loadDetail = true;
      } catch (error) {
        return;
      }
    },
    // AiBrief List Title api 호출
    async getAibriefTitleList(context) {
      try {
        let language = context.state.langSelect;
        let limit = context.state.limit;
        let timetype = context.state.timetype;

        const result = await api.getAiBriefTitle(limit, timetype, language);

        for (let title of result) {
          let [date, time] = title.title.split(" ");

          title.date = date;
          title.time = time;

          if (!context.state.aiId.includes(title.id)) {
            context.state.aiId.push(title.id);
          }
        }

        context.state.aiBriefTitleList = result;
        context.state.loadBrief = true;
      } catch (error) {
        return;
      }
    },
  },
};
